<template>
  <div class="main-area">
    <div class="main2">
      <div class="main_top1">
        <input
          class="tilete_class"
          v-model="testInsertParam.testPaperName"
          :maxlength="45"
          placeholder="这里是考试名称"
        />
      </div>
      <div class="main_top2">

       <div class="main_top2_left1">
        <BBtnSecondary
          :img-src="require('@/assets/new.png')"
          :clicked="addTestPaperQuestion"
          btn-txt="添加题目"
        />
        </div>
        <div class="main_top2_left">
          <label
            >共{{ testInsertParam.questionTotalNum }}道题,总分{{
              testInsertParam.questionTotalScore
            }}分</label
          >
        </div>
        <div class="main_top2_right">
              <BBtnPrimary
                :clicked="doSaveActualTestPager"
                hidden-key="点击事件主按钮"
                btn-txt="保存"
              />
            </div>
          </div>
    </div>
    <div>
      <div
        v-for="(testPaperItem, testPaperIndex) in testPaperList"
        :key="testPaperIndex"
        class="box"
      >
        <div style="height: 24px" />
        <div style="display: inline-block">
          <div class="main3">
            <label class="acore_class"
              >{{ testPaperItem.displayOrder }}.实操题</label
            >
            <div>
              <input
                :class="colorController(testPaperItem.questionScore)"
                v-model="testPaperItem.questionScore"
                @change="questionScoreCheck(testPaperItem.questionScore)"
              />
            </div>
            <label class="acore_class">分</label>
          </div>
          <div class="inner-box">
            <div class="testCont">
              <BInputTextArea
                style="width:100%"
                v-model="testPaperItem.questionContent"
                placeholder="请输入题干"
              />
            </div>
            <div class="delete_img">
              <BBtnIconDelete
                :clicked="delTestOuestionItem"
                :hiddenKey="testPaperIndex"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {
  actualTestQuestionDetail,
  actualTestQuestionSave,
  actualTestQuestionUpdate,
} from "@/api/testPaperQuestion";
import BBtnPrimary from "../../components2/BBtnPrimary";
import BBtnSecondary from "../../components2/BBtnSecondary";
import BBtnIconDelete from "../../components2/BBtnIconDelete";
import PopupContents from "../../views2/sample/PopupContents";
import BInputTextArea from "../../components2/BInputTextArea";
import Hub from "../../events/Hub";
import Vue from "vue";
export default {
  name: "StudentManagement",
  components: {
    BBtnPrimary,
    BBtnIconDelete,
    BInputTextArea,
    BBtnSecondary,
  },
  data: () => ({
    menu: false,
    menu1: false,
    landscape: true,
    deleteSuccess: false,
    loading: false,
    totalPages: 0,
    pageNum: 1,
    pageCount: 10,
    totalCount: 0,
    searchParam: {},
    timeout: 3000,
    snackbarColor: "success",
    snackbarText: "",
    data: {},
    scoreLiset: {},
    beforeScore: 0,
    beforeIndex: 0,
    colorrId: 0,
    headers: [
      { text: "ID", value: "indexNum", sortable: false, align: "center" },
      { text: "考试名称", value: "testPaperName", sortable: false },
      { text: "课程", value: "trainCourseName", sortable: false },
      {
        text: "考试类型",
        value: "testPaperType",
        sortable: false,
        align: "center",
      },
      { text: "创建人", value: "createUserName", sortable: false },
      { text: "创建时间", value: "createTime", sortable: false },
      { text: "操作", value: "actions", sortable: false },
    ],
    courseNameList: [],
    statusList: [],
    id: 0,
    deleteID: null,
    insertParam: {
      questionType: "", //试题类型 单选 多选 判断
      questionScore: "", //questionScore
      questionContent: "", //题目内容
      optionList: [
        {
          answerFlg: "",
          content: "",
        },
      ],
    },
    tagList: [],
    questionTypeList: [],
    organizationNameList: [],
    selectServiceList: [],
    judgeList: ["正确", "错误"],
    testPaperList: [
      {
        displayOrder: 1,
        questionType: "01", //试题类型 单选 多选 判断
        questionScore: "", //questionScore
        questionContent: "", //题目内容
        optionList: [],
      },
    ],
    testInsertParam: {
      id: null,
      testPaperName: "新建实操考试", //试题名称
      subjectType: "02", //主题类型（01：普通作业  02：考试作业）
      testPaperType: "02", //作业类型（01：理论   02：实操）
      questionTotalNum: 1, //题目总数
      questionTotalScore: 0, //试题名称
    },
    actualTestPagerId: "",
    navi: [
      { name: "test-paper-release" },
      { name: "test-paper-bank" },
      { name: "test-paper-bank-practice-add" },
    ],
  }),
  created() {
    // 页面初期化
    this.comUtils.saveStorage(this.$store);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 页面初期化
      vm.actualTestPagerId = vm.$route.query.actualTestPagerId;

      if (
        vm.actualTestPagerId !== null &&
        vm.actualTestPagerId !== "" &&
        vm.actualTestPagerId !== undefined
      ) {
        // 把不为空的参数存入缓存
        const storageParams = {
          actualTestPagerId: vm.actualTestPagerId,
        };
        vm.$store.commit(
          "SET_TEST_MANAGEMENT_DETAIL_ACTUAL_PARAMS",
          storageParams
        );
      }
      // 查询条件赋值
      if (
        vm.$store.state.testPagerBank_actualTestPagerId !== undefined &&
        vm.$store.state.testPagerBank_actualTestPagerId !== null &&
        vm.$store.state.testPagerBank_actualTestPagerId !== ""
      ) {
        vm.actualTestPagerId = vm.$store.state.testPagerBank_actualTestPagerId;
      }
      if (
        vm.actualTestPagerId !== null &&
        vm.actualTestPagerId !== "" &&
        vm.actualTestPagerId !== undefined
      ) {
        // 初始化
        const params = {
          id: vm.actualTestPagerId,
        };
        vm.getTestPagerDetail(params);
      }
    });
  },
  beforeMount() {
    this.$store.commit("SET_NAVI_DATA", this.navi);
  },
  methods: {
    // 点击详情
    getTestPagerDetail(item) {
      this.fetchData(item);
    },
    async fetchData(params) {

      const data = await actualTestQuestionDetail(params);

      this.testInsertParam.id = data.data.id;
      this.testInsertParam.testPaperName = data.data.testPaperName;
      this.testInsertParam.subjectType = data.data.subjectType;
      this.testInsertParam.testPaperType = data.data.testPaperType;
      this.testInsertParam.questionTotalNum = data.data.questionTotalNum;
      this.testInsertParam.questionTotalScore = data.data.questionTotalScore;
      this.testPaperList = data.data.paperQuestionList;
    },
    // 点击详情
    handleDetail(item) {
      this.$router.push({
        name: "page-management-detail",
        params: {
          pageId: item,
        },
      });
    },
    // A~Z的取得
    getCharCode(index) {
      const str = "A";
      return String.fromCharCode(str.charCodeAt() + index);
    },
    // 选项提示语
    getOptionMessage(index) {
      return "请输入选项" + this.getCharCode(index);
    },
    // 添加题型
    addTestOption(testPaperItem) {
      var testOption = {
        answerFlg: "",
        content: "",
      };
      testPaperItem.optionList.push(testOption);
    },
    // 删除题型按钮表示
    showDelTestOption(testPagerParam, index) {
      var count = 1;
      if (testPagerParam.questionType === "02") {
        count = 2;
      }
      if (index > parseInt(count)) {
        return true;
      } else {
        return false;
      }
    },
    // 删除题型
    delTestOption(testPagerParam, index) {
      testPagerParam.optionList.splice(index, 1);
    },
    optionClick(index) {
      for (var i = 0; i < this.insertParam.optionList.length; i++) {
        if (i === index) {
          this.insertParam.optionList[i].answerFlg = "1";
        } else {
          this.insertParam.optionList[i].answerFlg = "";
        }
      }
    },
    // 删除项目
    delTestOuestionItem(e) {
      this.data.bodyText = "确认删除该题目?";
      Hub.$emit("open-modal");
      Hub.$emit("set-modal-data", this.data.bodyText, "提示", PopupContents);
      this.deleteID = e;
    },
    delTest() {
      this.testPaperList.splice(this.deleteID, 1);
      this.testInsertParam.questionTotalNum =
        this.testInsertParam.questionTotalNum - 1;
      var score = 0;
      for (var i = 0; i < this.testPaperList.length; i++) {
        score += Number(this.testPaperList[i].questionScore);
        this.testPaperList[i].displayOrder = i + 1;
      }
      this.testInsertParam.questionTotalScore = score;
    },
    // 点击按钮添加
    addTestPaperQuestion() {
      this.colorrId = 0;
      var questionParam = this.getQuestionParam();
      this.testPaperList.push(questionParam);
      this.testInsertParam.questionTotalNum = this.testPaperList.length;
    },
    // 添加
    getQuestionParam() {
      var questionParam = {};
      questionParam.displayOrder = this.testPaperList.length + 1;
      questionParam.questionType = "";
      questionParam.questionScore = "";
      questionParam.questionContent = "";
      questionParam.optionList = [];
      return questionParam;
    },
    questionScoreCheck(questionScore){
      if (String(questionScore) !== 
            String(questionScore).replace(/[^\\.\d]/g, '').replace('.', '') 
        || questionScore === '0') {
          Vue.prototype.$valertbar.show('输入的分数必须为正整数！');
          return
        }
        var score = 0
      for (var i=0;i<this.testPaperList.length;i++) {
        score = Number(score) + Number(this.testPaperList[i].questionScore)
      }
      this.testInsertParam.questionTotalScore = score
    },
    // 分数颜色控制
    colorController(item) {
      if (!item && this.colorrId === 1) {
        return "questionScoreR_class";
      }
      return "questionScore_class";
    },
    // 保存或更新试卷
    doSaveActualTestPager() {
      // 题目个数
      if(this.testPaperList.length == 0){
        Vue.prototype.$valertbar.show('没有题目明细，不能保存');
        return;
      }      
      // 判断标题
      if (this.testInsertParam.testPaperName == "") {
        Vue.prototype.$valertbar.show("考试题目不能为空");
        return;
      }
      // 判断分数
      for (var i = 0; i < this.testPaperList.length; i++) {
        if (!this.testPaperList[i].questionScore) {
          this.colorrId = 1;
          this.data.bodyText = "第" + (i + 1) + "道题目分值为空!";
          Vue.prototype.$valertbar.show(this.data.bodyText);
          return;
        }

        var newScore = this.testPaperList[i].questionScore
         if (String(newScore) !== 
              String(newScore).replace(/[^\\.\d]/g, '').replace('.', '') 
          || newScore === '0') {
            Vue.prototype.$valertbar.show('第' + (i + 1) + '道题目输入的分数必须为正整数！');
            return;
          }
      }


      // 判断内容
      for (var a = 0; a < this.testPaperList.length; a++) {
        if (!this.testPaperList[a].questionContent) {
          Vue.prototype.$valertbar.show("第" + (a + 1) + "道题内容为空!");
          return;
        }
      }


      // 保存
      if (this.testInsertParam.id === null) {
        this.doSave();
      } else {
        this.doUpdate();
      }
    },
    // 保存
    async doSave() {
      var paperQuestionList = this.testPaperList;
      this.testInsertParam.paperQuestionList = paperQuestionList;
      const data = await actualTestQuestionSave(this.testInsertParam);
      if (data.code === 0) {
        this.testInsertParam.id = data.data
        this.snackbarText = "保存成功";
        Vue.prototype.$vsnackbar.show(this.snackbarText);
      } else {
        this.snackbarText = data.msg;
        Vue.prototype.$valertbar.show(this.snackbarText);
      }
    },
    // 保存
    async doUpdate() {
      var paperQuestionList = this.testPaperList;
      this.testInsertParam.paperQuestionList = paperQuestionList;
      const data = await actualTestQuestionUpdate(this.testInsertParam);
      if (data.code === 0) {
        this.snackbarText = "更新成功";
        Vue.prototype.$vsnackbar.show(this.snackbarText);
      } else {
        this.snackbarText = data.msg;
        Vue.prototype.$valertbar.show(this.snackbarText);
      }
    },
    // 添加编辑页面返回值
    set(value) {
      if (value == 1) {
        // 成功 页面刷新
        this.delTest();
      }
    },
  },
  destroyed() {
    this.$store.commit("REMOVE_TEST_MANAGEMENT_DETAIL_ACTUAL_PARAMS");
    Hub.$off("modal-confirm", this.set);
  },
  mounted() {
    this.$nextTick(
      function() {
        Hub.$on("modal-confirm", this.set);
      }.bind(this)
    );
  },
};
</script>

<style lang="scss" scoped>
.inner-box {
  display: flex;
  flex-direction: row;
}
.delete_img {
  display: flex;
  flex-direction: row;
  width: auto;
  justify-content: flex-end;
  margin-top: 30px;
  margin-left: 10px;
}
.main3 {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-left: 50px;
}
.lable {
  margin-left: 30px;
  margin-right: 20px;
}
.search-functions {
  display: flex;
  margin-left: 1450px;
}
.deleteBtn {
  display: inline-block;
  margin-left: 1450px;
}
.delete {
  width: 40px;
  height: 40px;
  margin-top: 13px;
  margin-left: 10px;
}
.addBtn {
  margin-left: 20px;
  width: 120px;
}
.title_class {
  display: flex;
  margin-left: 550px;
}
.btn-detail {
  margin: 0 20px 0 20px;
  color: #0171a3;
  cursor: pointer;
}
.box {
  display: flex;
  flex-direction: column;
  border: 1px solid #dee2e6;
  margin-bottom: 40px;
  margin-left: 20px;
  margin-right: 20px;
}
.saveBtn {
  width: 100px;
}
.tilete_class {
  font-size: 20px;
  border: none;
  width: 700px;
  height: 30px;
  background: #ffffff;
  border-radius: 5px;
  padding-left: 8px;
  padding-right: 8px;
  margin: 12px 0 0 0;
  text-align: center;
}
.tilete_class2 {
  font-size: 12px;
  border: none;
  width: 215px;
  height: 30px;
  border-radius: 5px;
  padding-left: 8px;
  padding-right: 8px;
  margin: 12px 0 0 0;
  text-align: center;
}
.acore_class {
  margin-top: 10px;
}
.questionScore_class {
  width: 215px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  padding-left: 8px;
  padding-right: 8px;
  margin: 0 10px 12px 10px;
}
.questionScoreR_class {
  width: 215px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #ff4507;
  border-radius: 5px;
  padding-left: 8px;
  padding-right: 8px;
  margin: 0 10px 12px 10px;
}
.questioncontent_class {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin-left: 62px;
}
.testCont {
  display: flex;
  flex-direction: row;
  width: 90%;
  height: 100px;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  margin: 12px 0 12px 50px;
}
.main-area {
  display: block;
  padding-bottom: 50px;
}
.main2 {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
  width: 100%;
  height: 140px;
}
.main_top1 {
  display: flex;
  padding-top: 20px;
  width: 100%;
  height: 80px;
  justify-content: center;
}
.main_top2 {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
}
.main_top2_left1 {
  display: flex;
  flex-direction: row;
  width: 9%;
  height: 60px;
  justify-content: flex-end;
  padding-left: 0px;
}
.main_top2_left {
  display: flex;
  flex-direction: row;
  width: 52%;
  height: 60px;
  justify-content: flex-end;
}
.main_top2_right {
  display: flex;
  flex-direction: row;
  width: 50%;
  height: 60px;
  justify-content: flex-end;
  margin-right: 50px;
}
</style>
